const CustomFonts = [
    { font: "Roboto", name: "Roboto" },
    { font: "Montserrat Variable", name: "Montserrat" },
    { font: "Nunito Sans Variable", name: "Nunito Sans" },
    { font: "Poppins", name: "Poppins" },
    { font: "Sora Variable", name: "Sora" },
    { font: "Ubuntu", name: "Ubuntu" },
    { font: "Bebas Neue", name: "Bebas Neue" },
    { font: "Bangers", name: "Bangers" },
    { font: "Amaranth", name: "Amaranth" },
    { font: "Saira Variable", name: "Saira" },
    { font: "Gabarito Variable", name: "Gabarito" },
    { font: "Onest Variable", name: "Onest" },
    { font: "Pixelify Sans Variable", name: "Pixelify Sans" },
    { font: "Kufam Variable", name: "Kufam" },
    { font: "Monomaniac One", name: "Monomaniac One" },
    { font: "Cuprum", name: "Cuprum" },
    { font: "Paytone One", name: "Paytone One" },
    { font: "Luckiest Guy", name: "Luckiest Guy" },
    { font: "Jockey One", name: "Jockey One" },
    { font: "Passion One", name: "Passion One" },
    { font: "Silkscreen", name: "Silkscreen" },
    { font: "Contrail One", name: "Contrail One" },
    { font: "Rubik One", name: "Rubik One" },
];

export default CustomFonts;
